// extracted by mini-css-extract-plugin
module.exports = {"contractIcon":"BidForm_contractIcon_11hUF","label":"BidForm_label_3LOSS"};